// TileType union values + palette mapping

export const TILE_TYPES = [
  'ocean',
  'grass',
  'grassland',
  'mountain',
  'snow',
  'desert',
  'deadplains',
];

export const TILE_COLORS = {
  ocean:      '#3498db',
  grass:      '#7ecc49',
  grassland:  '#a8d86e',
  mountain:   '#8B6914',
  snow:       '#ecf0f1',
  desert:     '#f1c40f',
  deadplains: '#7a6b5d',
};

export const RESOURCE_TYPES = ['fish','food','wood','stone','supplies','gold','crystals'];

export const RESOURCE_EMOJI = {
  fish:     '🐟',
  food:     '🌾',
  wood:     '🪵',
  stone:    '🪨',
  supplies: '📦',
  gold:     '🪙',
  crystals: '💎',
};

export const TILE_EMOJI = {
  ocean:      '🐟',
  grass:      '🐑',
  grassland:  '🌾',
  mountain:   '🪙',
  snow:       '❄️',
  desert:     '🏜️',
  deadplains: '🪨',
};
